export default {"src":"/_next/static/media/Neurology.dfaff487.svg","height":91,"width":90,"blurWidth":0,"blurHeight":0};